import { LiveFeedEvent } from './liveFeed';

export enum SocketEventType {
  NewLiveFeedEvents = 'newLiveFeedEvents',
}

export type LiveFeedEventPayload = {
  date: string;
  events: LiveFeedEvent[];
};

export type SocketMessage = {
  type: SocketEventType;
  payload: LiveFeedEventPayload;
};
